import { docLabel } from "@/lib/api";
import { useApp } from "@/context/AppContext";

export function SourceBadge({ src, onOpen }) {
  const app = useApp();
  if (!src?.doc_id) return null;
  const open = onOpen || app.openSource;
  return (
    <button
      data-testid={`source-badge-${src.doc_id}-p${src.page}`}
      onClick={(e) => { e.stopPropagation(); open({ doc_id: src.doc_id, page: src.page, snippet: src.snippet }); }}
      className="inline-flex items-center gap-1 text-[10px] num px-1.5 py-0.5 rounded border border-sky-500/40 text-sky-700 bg-sky-600/5 hover:bg-sky-600/15 transition-colors whitespace-nowrap"
    >
      {docLabel(src.doc_id)} p.{src.page}
    </button>
  );
}
